import Link from 'next/link'
import { format } from 'date-fns'
import ResponsiveImage from '../common/ResponsiveImage'
import ContentContainer from './ContentContainer'

interface EventsListProps {
	heading?: string
	addArchiveLink?: any
	events: Array<any>
}

const EventsList = (props: EventsListProps) => {

	const { heading, addArchiveLink, events } = props

	if ( !events || events.length === 0 ) {
		return null
	}

	return (
		<ContentContainer
			heading={heading}
			modifierClass="add-margin-bottom"
			link={addArchiveLink ? <Link href="/events" className='button button--inverted'>View all events →</Link> : null}
		>
			{events.map((event: any) => {

				const image = event.previewImage && event.previewImage.length > 0 ? event.previewImage[0] : null

				return (
					<article key={event.id} className="event-card">
						<div className="event-card__wrapper">
							<div className="event-card__media">
								{image ? (
									<ResponsiveImage
										image={image}
										cleanImplementation={true}
										containerClass="event-card__media-container"
									/>
								) : (
									<div className="event-card__media-placeholder"></div>
								)}
							</div>
							<div className="event-card__content">
								<h3 className="event-card__title">{event.title}</h3>
								{event.startDate && (
									<div className="event-card__date">
										{`${format(new Date(event.startDate), 'dd. MMMM yyyy')}`}<br />
										{`${format(new Date(event.startDate), 'HH:mm')}`}
									</div>
								)}
								{event.previewText && <div className="event-card__body" dangerouslySetInnerHTML={{ __html: event.previewText }} />}
								<Link href={`/${event.uri}`} className='button button--inverted'>Read more →</Link>
							</div>
						</div>
					</article>
				)
			})}
		</ContentContainer>
	)

}
export default EventsList
